import getVariableFromString from "@/core/utils/getVariableFromString";
import { useGetPreviousAnswers } from "@/core/hooks/useGetPreviousAnswers/useGetPreviousAnswers";

const useDefaultValue = (defaultValue: any): any | null => {
  const isString = typeof defaultValue == "string";
  const variableName = isString
    ? getVariableFromString(defaultValue)
    : defaultValue;
  const { result } = useGetPreviousAnswers(
    isString && variableName ? variableName : "",
    {
      dataIsRequired: false,
    }
  );

  if (!defaultValue) return null;
  if (!variableName || typeof defaultValue == "boolean") return defaultValue;

  return result[variableName] ?? null;
};

export { useDefaultValue };
